<template>
  <a-row :gutter="[8, 8]" style="padding: 8px; width: 320px">
    <a-col :span="24">
      <a-range-picker
        style="width: 100%"
        :value="props.selectedKeys.length ? props.selectedKeys : []"
        @change="onRangeChange"
        :format="['DD-MM-YYYY', 'DD-MM-YYYY']"
      />
    </a-col>
    <a-col :span="12">
      <a-button
        type="primary"
        @click="() => props.confirm()"
        size="small"
        block
      >
        <template #icon>
          <SearchOutlined />
        </template>
        Buscar
      </a-button>
    </a-col>
    <a-col :span="12">
      <a-button @click="onClear" size="small" block>
        <template #icon>
          <CloseCircleOutlined />
        </template>
        Reiniciar
      </a-button>
    </a-col>
  </a-row>
</template>

<script setup>
import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons-vue';
import { defineProps } from 'vue';

const props = defineProps([
  'setSelectedKeys',
  'selectedKeys',
  'confirm',
  'clearFilters'
]);

function onRangeChange(dates) {
  if (dates && dates.length > 0) {
    props.setSelectedKeys([
      dates[0] ? dates[0] : null,
      dates[1] ? dates[1] : null
    ]);
  } else {
    props.setSelectedKeys([]);
  }
}

function onClear() {
  props.setSelectedKeys([]);
  props.clearFilters();
}
</script>
